<template>
  <div class="main-card">
    <div class="main-card__head">
      <div class="text-center">
        <MainCardCarSvg />
        <h1 v-html="missionInfos.title_html"></h1>
        <img v-if="assistanceLogoUrl" :src="assistanceLogoUrl" :alt="missionInfos.mission_data.assistance_name.value" class="assistance-logo">
      </div>

      <div class="mb-3">
        <h2>
          {{ $t('missions_infos.company_name.title') }}
        </h2>
        <div class="company-id d-flex align-items-center">
          <div class="company-logo">
          <img v-if="missionInfos.company_data.logo_tag_url" :src="missionInfos.company_data.logo_tag_url" class="logo">
          <CompanyDefaultPictureSvg v-else />
        </div>

          <div class="company-infos">
            <div class="fw-bold">
              {{ missionInfos.company_data.name }}
            </div>
            <div class="fw-normal" v-html="missionInfos.company_data.address">
            </div>
          </div>
        </div>
      </div>

      <h2>
        {{ $t('missions_infos.driver_name.title') }}
      </h2>
      <div class="driver-id d-flex align-items-center">
        <div class="driver-picture">
          <DriverAvatar :missionInfos="missionInfos" />
        </div>

        <div class="driver-infos">
          <div class="fw-bold">
            {{ missionInfos.driver_data.name.value }}
          </div>
        </div>
      </div>
    </div>

    <div class="main-card__body">
      <div v-if="isNotNullOrUndefined(missionInfos.mission_data.assistance_name.value)" class="intervention-infos">
        <div>{{ missionInfos.mission_data.assistance_name.title }}</div>
        <div>{{  missionInfos.mission_data.assistance_name.value }}</div>
      </div>
      <div class="intervention-infos">
        <div>{{ missionInfos.mission_data.external_id.title }}</div>
        <div>{{ missionInfos.mission_data.external_id.value }}</div>
      </div>
      <div class="intervention-infos">
        <div>{{ missionInfos.mission_data.beneficiary_phone_number.title }}</div>
        <div>{{ missionInfos.mission_data.beneficiary_phone_number.value }}</div>
      </div>
      <div class="intervention-infos">
        <div>{{ missionInfos.mission_data.intervention_planned_at.title }}</div>
        <div>
          {{ interventionPlannedDisplay }}
        </div>
      </div>
      <div class="intervention-infos mb-0">
        <div>{{ missionInfos.mission_data.intervention_address.title }}</div>
        <div>{{ missionInfos.mission_data.intervention_address.value }}</div>
      </div>
    </div>
  </div>

</template>

<script>
  import CompanyDefaultPictureSvg from '@images/CompanyDefaultPictureSvg.vue';
  import MainCardCarSvg from '@images/MainCardCarSvg.vue';
  import DriverAvatar from '@components/utils/DriverAvatar.vue';
  import { isNotNullOrUndefined } from '@lib/utilities'
  import { assistanceLogoUrl } from '@lib/assistanceLogos'

  export default {
    components: {
      DriverAvatar,
      CompanyDefaultPictureSvg,
      MainCardCarSvg
    },
    props: {
      missionInfos: Object,
      missionCardMounted: Boolean
    },
    methods: {
      isNotNullOrUndefined
    },
    computed: {
      // Logo of the assistance the case is handled under, or nothing when no logo ships
      // for its key.
      assistanceLogoUrl() {
        return assistanceLogoUrl(this.missionInfos.mission_data.assistance_logo_key);
      },
      interventionPlannedDisplay() {
        const plannedAt = this.missionInfos.mission_data.intervention_planned_at.value;
        const before = this.missionInfos.mission_data.arrival_window_minutes_before;
        const after = this.missionInfos.mission_data.arrival_window_minutes_after;

        const hasBefore = isNotNullOrUndefined(before);
        const hasAfter = isNotNullOrUndefined(after);

        if (!hasBefore && !hasAfter) return plannedAt;

        let window;
        if (hasBefore && hasAfter) {
          window = `-${before} min / +${after} min`;
        } else if (hasBefore) {
          window = `-${before} min`;
        } else {
          window = `+${after} min`;
        }

        return `${plannedAt} (${window})`;
      }
    },
    mounted() {
      this.$emit('update:missionCardMounted', true);
    },
  };
</script>
